import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import NotFound from './pages/NotFound';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import CheckoutPage from './pages/CheckoutPage';

function App() {
  return (
    // Raiz num pay.<corp>; um caminho (ex: /pagar) quando a página vive dentro
    // do site principal do corp. Vem do PUBLIC_URL do build.
    <Router basename={process.env.PUBLIC_URL || '/'}>
      <Routes>
        <Route path="/:token" element={<LandingPage />} />

        {/* Checkout Stripe no domínio do corp */}
        <Route path="/checkout/:token" element={<CheckoutPage />} />

        {/* Rotas informativas */}
        <Route path="/success/:token" element={<SuccessPage />} />
        <Route path="/cancel/:token" element={<CancelPage />} />

        <Route path="/" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
